export const getMajorVersion = (version: string) => {
  // remove leading 'v' if it exists and split by '.'
  const versionParts = version.replace(/^v/, '').split('.');
  // return the first part of the version
  return Number.parseInt(versionParts[0] ?? '') ?? 0;
};
